import React, { useState, useRef, useEffect } from "react";

const Hero = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [textVisible, setTextVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const handleLoaded = () => {
      setIsLoaded(true);
      // Trigger text animation after video loads
      setTimeout(() => setTextVisible(true), 300);
    };
    v.addEventListener("loadeddata", handleLoaded);
    return () => v.removeEventListener("loadeddata", handleLoaded);
  }, []);

  // Subtle parallax effect
  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY;
      setScrollY(scroll);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative w-full h-[78vh] lg:h-screen overflow-hidden bg-black">
      
      {/* Background Video */}
      <video
        ref={videoRef}
        className="absolute top-0 left-0 w-full h-full object-cover"
        preload="metadata"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="/Videos/Domigo_Video2.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Loading spinner (shows until video has loaded enough to play) */}
      <div className={`absolute inset-0 z-20 flex items-center justify-center transition-opacity duration-500 ${isLoaded ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-white/30 border-t-white rounded-full animate-spin"></div>
          <span className="text-white/90">Loading video…</span>
        </div>
      </div>

      {/* Dark Overlay with gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-black/75 z-10"></div>

      {/* Left-aligned Welcome Text with smooth entrance animation and subtle parallax */}
      <div 
        className="absolute inset-0 z-30 flex items-center justify-start pl-2 pr-4 sm:pl-4 sm:pr-8 md:pl-8 md:pr-16 lg:pl-12 lg:pr-20"
        style={{
          transform: `translateY(${scrollY * 0.3}px)`,
          transition: 'transform 0.1s ease-out'
        }}
      >
        <div className={`max-w-xl lg:max-w-2xl transition-all duration-1000 ease-out ${
          textVisible 
            ? 'opacity-100 translate-x-0' 
            : 'opacity-0 -translate-x-12'
        }`}>
          <h1 className="text-white text-left font-semibold leading-tight text-xl sm:text-2xl md:text-3xl lg:text-[2rem] drop-shadow-2xl" style={{
            textShadow: '0 4px 12px rgba(0,0,0,0.5), 0 2px 4px rgba(0,0,0,0.3)'
          }}>
            Welcome to Domigo — where care feels like home, and every stay becomes a story.
          </h1>
        </div>
      </div>

    </section>
  );
};

export default Hero;
